<template>
  <div class="row page-header">
    <div class="col-12 col-lg-6">
      <h1>
        {{ $route.meta.title | i18n }}
      </h1>
    </div>
    <div class="col-12 col-lg-6">
      <div class="action-buttons">
        <slot name="action-buttons" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
};
</script>
